var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0b1eaef6edfc404b4ec7af29b4457f3dae9d33ae"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"0b1eaef6edfc404b4ec7af29b4457f3dae9d33ae"};
      